import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        username: null,
        accessToken: null,
        refreshToken: null,
    },
    reducers: {
        setCredentials: (state, action) => {
            state.username = action.payload.username;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
        },
        clearCredentials: (state) => {
            state.username = null;
            state.accessToken = null;
            state.refreshToken = null;
        }
    }
});

// Export actions for use in components
export const { setCredentials, clearCredentials } = authSlice.actions;

// Export the reducer to be included in the store
export default authSlice.reducer;